'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useEffect, useMemo, ReactNode } from 'react';
import { useSearchParams } from 'next/navigation';
import { useCookies } from 'next-client-cookies';
import { usePathname, useRouter } from '@/i18n/navigation';
import { useAppLocale, useTranslatedRoute } from '@/hooks';
import { useLogoutStore, useMeStore } from '@/store';
import { setIsOnProtectedRoute } from '@/lib/axios';
type SessionContextType = {
  user: any | null;
  sessionIsLoading: boolean;
  isAuthenticated: boolean;
  sessionError: any | null;
  resetSession: () => void;
};
export const SessionContext = createContext<SessionContextType | null>(null);
type SessionProviderProps = {
  children: ReactNode;
  requireAuth?: boolean;
};
export const SessionProvider = t0 => {
  const $ = _c(38);
  const {
    children,
    requireAuth: t1
  } = t0;
  const requireAuth = t1 === undefined ? true : t1;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    locale
  } = useAppLocale();
  const {
    buildRoute
  } = useTranslatedRoute();
  const cookies = useCookies();
  let t2;
  if ($[0] !== buildRoute) {
    t2 = buildRoute("login");
    $[0] = buildRoute;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const loginRoute = t2;
  const {
    meState,
    reset
  } = useMeStore();
  const {
    logoutState
  } = useLogoutStore();
  let t3;
  let t4;
  if ($[2] !== requireAuth) {
    t3 = () => {
      if (requireAuth) {
        setIsOnProtectedRoute(true);
        return _temp;
      }
    };
    t4 = [requireAuth];
    $[2] = requireAuth;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  const {
    response: user,
    isLoading,
    error
  } = meState;
  let t5;
  if ($[5] !== cookies) {
    t5 = cookies.get("accessToken");
    $[5] = cookies;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const hasToken = !!t5;
  let t6;
  if ($[7] !== error?.status || $[8] !== isLoading || $[9] !== locale || $[10] !== loginRoute || $[11] !== logoutState.isLoggedOut || $[12] !== pathname || $[13] !== requireAuth || $[14] !== router || $[15] !== searchParams || $[16] !== user) {
    t6 = () => {
      if (!requireAuth) {
        return;
      }
      const isUnauthorized = !isLoading && !user && error?.status === 401 || logoutState.isLoggedOut;
      if (!isUnauthorized) {
        return;
      }
      const queryString = searchParams.toString();
      const next = `/${locale}${queryString ? `${pathname}?${queryString}` : pathname}`;
      router.push(`/${loginRoute}?next=${next}`, {
        locale
      });
    };
    $[7] = error?.status;
    $[8] = isLoading;
    $[9] = locale;
    $[10] = loginRoute;
    $[11] = logoutState.isLoggedOut;
    $[12] = pathname;
    $[13] = requireAuth;
    $[14] = router;
    $[15] = searchParams;
    $[16] = user;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== error || $[19] !== isLoading || $[20] !== locale || $[21] !== loginRoute || $[22] !== logoutState.isLoggedOut || $[23] !== pathname || $[24] !== requireAuth || $[25] !== router || $[26] !== searchParams || $[27] !== user) {
    t7 = [requireAuth, isLoading, user, error, logoutState.isLoggedOut, router, loginRoute, locale, pathname, searchParams];
    $[18] = error;
    $[19] = isLoading;
    $[20] = locale;
    $[21] = loginRoute;
    $[22] = logoutState.isLoggedOut;
    $[23] = pathname;
    $[24] = requireAuth;
    $[25] = router;
    $[26] = searchParams;
    $[27] = user;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  useEffect(t6, t7);
  const t8 = isLoading || hasToken && !user && !error || requireAuth && logoutState.isLoggedOut;
  const t9 = !!user;
  let t10;
  if ($[29] !== error || $[30] !== reset || $[31] !== t8 || $[32] !== t9 || $[33] !== user) {
    t10 = {
      user,
      sessionIsLoading: t8,
      sessionError: error,
      isAuthenticated: t9,
      resetSession: reset
    };
    $[29] = error;
    $[30] = reset;
    $[31] = t8;
    $[32] = t9;
    $[33] = user;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  const value = t10;
  let t11;
  if ($[35] !== children || $[36] !== value) {
    t11 = <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
    $[35] = children;
    $[36] = value;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  return t11;
};
export default SessionProvider;
function _temp() {
  return setIsOnProtectedRoute(false);
}